import { useCallback } from "react";
import { useTranslation as useTranslation$1 } from "react-i18next";
function useTranslation() {
  const { t, ready } = useTranslation$1("omega", { useSuspense: false });
  return { t: useCallback((key) => ready ? t(key) : key, [ready, t]) };
}
export {
  useTranslation
};
//# sourceMappingURL=useTranslation.js.map
